import { render, staticRenderFns } from "@/modules/DashboardCalendar/templates/calendar.html?vue&type=template&id=790a973c&scoped=true&"
import script from "@/modules/DashboardCalendar/scripts/calendar.ts?vue&type=script&lang=js&"
export * from "@/modules/DashboardCalendar/scripts/calendar.ts?vue&type=script&lang=js&"
import style0 from "@/modules/DashboardCalendar/styles/calendar.scss?vue&type=style&index=0&id=790a973c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a973c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCalendar,VCard,VIcon,VSheet})
